export type NewsCategory = "电影新闻" | "电视剧新闻" | "综合资讯";

export interface NewsItem {
  id: string;
  title: string;
  category: NewsCategory;
  summary: string;
  content: string[];
  date: string;
}

export const newsList: NewsItem[] = [
  {
    id: "n001",
    title: "《星海回响》发布首支正式预告，深空孤独感引发热议",
    category: "电影新闻",
    summary:
      "科幻新作《星海回响》释出首支正式预告，两分半钟的画面几乎没有对白，却把“宇宙级孤独”拍得令人窒息。",
    content: [
      "《星海回响》今日发布首支正式预告。整支预告以一段断续的信号音贯穿，画面在空旷的信号站与浩瀚星海之间来回切换，台词寥寥，情绪却层层递进。",
      "导演顾南舟在采访中表示，影片想讨论的并不是科幻设定本身，而是“人如何在巨大的孤独里仍然选择回应”。团队为此搭建了完整的信号站实景，大量镜头在真实空间中一次拍摄完成。",
      "影片预计将于年内与观众见面。（本站内容为示例资讯，仅用于展示页面结构）",
    ],
    date: "2026-10-12",
  },
  {
    id: "n002",
    title: "《长夜将尽》口碑走高，审讯室里的心理博弈成最大看点",
    category: "电视剧新闻",
    summary:
      "悬疑剧集《长夜将尽》播出过半，几乎全部情节都发生在十二小时内的审讯室里，却被观众称为“全程不敢快进”。",
    content: [
      "《长夜将尽》自开播以来口碑持续走高。全剧最受讨论的，是它把绝大部分时间都安排在一间审讯室中，仅靠对话与表演推进剧情。",
      "主创团队透露，为了让审讯室里的每一句台词都经得起推敲，剧本在开拍前经历了十余次打磨。演员傅沉与纪云舒的对手戏也成为观众反复回看的部分。",
      "本剧已更新过半，结局将于本月底揭晓。（本站内容为示例资讯，仅用于展示页面结构）",
    ],
    date: "2026-10-10",
  },
  {
    id: "n003",
    title: "行业观察：中小成本文艺片为何在这个秋天集中爆发",
    category: "综合资讯",
    summary:
      "从《南国旧事》到《山城理发店》，一批中小成本文艺作品在秋季档集中上映，它们的共同点是什么？",
    content: [
      "这个秋天，多部中小成本文艺片几乎同期上映，却都收获了超出预期的讨论度。它们的制作规模都不大，却把镜头对准了非常具体的人和生活。",
      "有从业者认为，观众对“真实感”的需求正在上升，愿意为那些能讲清楚一件小事、一段关系的作品走进影院。",
      "无论这一趋势能否持续，它至少说明一件事：好故事从来不取决于预算的多少。（本站内容为示例资讯，仅用于展示页面结构）",
    ],
    date: "2026-10-08",
  },
  {
    id: "n004",
    title: "《雾都迷踪》定档冬季，主创谈“把悬疑拍成一场雾”",
    category: "电影新闻",
    summary:
      "悬疑新片《雾都迷踪》宣布定档冬季，导演称影片的氛围本身就是最大的悬念来源。",
    content: [
      "《雾都迷踪》正式宣布定档今年冬季。影片以一桩二十年前的旧案为线索，讲述一位退休探员在浓雾中重新追寻真相的故事。",
      "导演艾德里安·科尔表示，剧组在摄制中刻意控制能见度，希望观众和角色一样“看不清前方”。",
      "更多物料将于上映前陆续释出。（本站内容为示例资讯，仅用于展示页面结构）",
    ],
    date: "2026-10-05",
  },
  {
    id: "n005",
    title: "《潮汐之下》收官，家庭题材如何拍出不煽情的感动",
    category: "电视剧新闻",
    summary:
      "《潮汐之下》迎来收官。整部剧几乎没有刻意的煽情段落，却让无数观众在最后一集落泪。",
    content: [
      "《潮汐之下》本周正式收官。全剧围绕渔港小镇三代女性展开，用大量留白和日常细节替代了常见的戏剧冲突。",
      "编剧柳如岚表示，她希望把“爱”藏在生活的褶皱里，而不是写在台词上。",
      "收官之后，关于剧中几位女性角色命运走向的讨论仍在持续。（本站内容为示例资讯，仅用于展示页面结构）",
    ],
    date: "2026-10-02",
  },
  {
    id: "n006",
    title: "院线之外：流媒体剧集正在改变观众的追剧节奏",
    category: "综合资讯",
    summary:
      "越来越多观众选择“攒满再看”，这对剧集的叙事方式提出了新的要求，也带来了新的可能。",
    content: [
      "随着流媒体剧集数量增加，越来越多观众选择“等完结再一次性看完”。这种观剧方式正在影响创作者对节奏的安排。",
      "有创作者认为，这并不意味着剧集必须变得更快，而是需要让每一集都具备独立的价值。",
      "观众的习惯还在变化，剧集的形式也会随之演进。（本站内容为示例资讯，仅用于展示页面结构）",
    ],
    date: "2026-09-28",
  },
  {
    id: "n007",
    title: "《午夜书店》续订新一季，主创承诺“不会重复自己”",
    category: "电视剧新闻",
    summary:
      "奇幻剧集《午夜书店》确认续订，主创表示新一季将把故事带到书店之外的地方。",
    content: [
      "备受欢迎的奇幻剧集《午夜书店》确认续订新一季。该剧以一家的午夜书店为核心，讲述每个人在这里找到“真正需要的那本书”的故事。",
      "主创团队表示，新一季会走出书店，去探索“书为什么会选择某一个人”。",
      "新一季的开播时间尚未公布。（本站内容为示例资讯，仅用于展示页面结构）",
    ],
    date: "2026-09-24",
  },
  {
    id: "n008",
    title: "从《荒原列车》看西部题材的当代表达",
    category: "电影新闻",
    summary:
      "《荒原列车》用一列火车装下了整片荒原，也装下了西部题材在当下最值得被讲述的部分。",
    content: [
      "《荒原列车》把故事压缩在一列穿越荒原的火车上，用有限的空间展开了多条人物线索。",
      "影片并没有沉迷于对西部片的怀旧，而是借由荒原这个母题，讨论当代人无处安放的孤独。",
      "该片目前正在院线放映中。（本站内容为示例资讯，仅用于展示页面结构）",
    ],
    date: "2026-09-20",
  },
];